import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  DirectionsPanelFormAddModal, type DirectionsPanelFormAddModalProps,
} from './directionsPanelFormAddModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    DirectionsPanelFormAdd: DirectionsPanelFormAddModalProps;
  }
}
modalRenderer.register('DirectionsPanelFormAdd', DirectionsPanelFormAddModal);
